import axios from '../../utils/axiosConfig'
import config from '../../utils/Config';
import axs from 'axios';

const getAllCounty = async() => {
    const response = await axios.get(config.basePath + 'common/getallcounty');
    return response.data;
}

const getSurveySelection = (urlcode) => {
    return new Promise((resolve, reject) => {
        let basepath = config.basePath
       // https://westedv2-stg.ugam-apps.com/wested/common/getsurveydashboard/
        axios.get('/wested/common/getsurveydashboard/' + urlcode).then((response) => {
            resolve(response.data)
            }).catch((err) => {
                if(err && err.response && err.response.data && err.response.data && err.response.data.message){
                    reject({
                        message: err.response.data.message
                    })
                } else {
                    reject({
                        message: "Unable to fetch survey data"
                    })
                }
            })
    })
}

const checkUserbyToken = async (token, password) => {
    return await axs.post(config.basePath + 'common/getuserbytoken', {token:token, password:password});
}
const getAcademicYear = async () => {
    const response = await axios.get(config.basePath + 'common/getAllAcademicYear');
    return response.data;
}

const getAcademicYearById = async (academicYearId) => {
    try {
        const response = await axios.get(`${config.basePath}common/getAcademicYearById/${academicYearId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching academic year:", error);
        throw error;
    }
}

const commonService = {
    getAllCounty,
    getSurveySelection,
    checkUserbyToken,
    getAcademicYear,
    getAcademicYearById
}

export default commonService;